function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h512v512h-512z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#4ad295"
}, /*#__PURE__*/React.createElement("path", {
  d: "m266 223.1h-54.9l-17.2-29.8h89.3l26.1-45.3h-147.6c-9.4 0-18.3 5-22.9 13.3-4.8 8.3-4.8 18.3 0 26.6l94.1 163.1c7.4 12.6 23.7 16.8 36.4 9.4 3.9-2.4 7.2-5.4 9.4-9.4l3-5.4-43.3-75.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m373.2 161.3c-4.8-8.3-13.5-13.3-22.9-13.3h-6.5l-70.8 122.4 25.9 45.3 74-128.1c5.1-8 5.1-18 .3-26.3z"
})));

function SvgFlaticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaticon);
export default __webpack_public_path__ + "static/media/flaticon.746b9c12.svg";
export { ForwardRef as ReactComponent };